import React from 'react';
import { ArrowRight } from 'lucide-react';

const CTASection = ({ onGetStarted }) => {
  return (
    <section 
      className="py-24 md:py-32 bg-[#2C3E50] relative overflow-hidden" 
      data-testid="cta-section"
      style={{
        backgroundImage: 'url(https://images.pexels.com/photos/5673483/pexels-photo-5673483.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-[#2C3E50]/85"></div>
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center relative z-10">
        <h2 className="text-3xl lg:text-4xl tracking-tight text-white font-bold mb-6">
          Start Your Legal Journey Today
        </h2>
        <p className="text-xl text-white/90 leading-relaxed mb-8">
          Get expert legal counsel from our experienced team. Contact us now for a consultation and discover how we can protect what matters most to your business.
        </p>
        <button
          onClick={onGetStarted}
          className="bg-[#CA9A67] text-white hover:bg-[#b8894f] transition-colors px-8 py-4 font-medium inline-flex items-center space-x-2"
          data-testid="cta-button"
        >
          <span>Get Started Now</span>
          <ArrowRight className="w-5 h-5" />
        </button>
      </div>
    </section>
  );
};

export default CTASection;
